import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";

import map from "../../images/Toronto-Map-Black-Line-3-1024x637.jpg";

const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const TextInfo = tw.div`py-6 sm:px-10 sm:py-6`;

const Content = tw.div`mt-16`;

const imageCss = tw`rounded-4xl`;

const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
const Subheading = tw.span`tracking-wider text-sm font-medium`;

const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-primary-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-primary-500`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;

export default () => {
  const cards = [
  ];

  return (
    <Container>
      <SingleColumn> 
        <HeadingInfoContainer>
          <HeadingTitle>Peak Season (June 1st to September 30th)</HeadingTitle>
          <TextInfo> Monday – Thursday: 9:00am – 10pm </TextInfo>
          <TextInfo> Friday – Sunday: 9:00am – 10pm </TextInfo>
          <HeadingTitle>Off Peak Season (May and October)</HeadingTitle>
          <TextInfo> Determined day by day. Please call ahead to confirm service. </TextInfo>
          <img src={map}></img>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2887.41505779841!2d-79.38024810000002!3d43.6395322!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cb2aa7422ccd%3A0xda1aabb4d1acc0c8!2sWater%20Taxi%20-%20Toronto%20Harbour%20Water%20Taxi%20-%20Est%201995!5e0!3m2!1sen!2sca!4v1659480659480!5m2!1sen!2sca" style={{paddingTop:"20px", border:"0", textAlign:"center",allowfullscreen:"false", loading:"lazy", referrerpolicy:"no-referrer-when-downgrade", width:"70%", height:"600px"}}></iframe>
        </HeadingInfoContainer>
        <Content>
        </Content>
      </SingleColumn>
      <SvgDotPattern1 />
      <SvgDotPattern2 />
      <SvgDotPattern3 />
      <SvgDotPattern4 />
    </Container>
  );
};
